import { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MessageContextProvider } from '@/common/contexts/message-context/MessageContext';
import LanguageContextProvider from '@/common/contexts/LanguageContext';
import AudioRecordingContextProvider from '@/common/contexts/AudioRecordingContext';
import { AnalyticsProvider } from '@/common/contexts/AnalyticsContext';
import { GuestAuthProvider } from '@/common/contexts/GuestAuthContext';
import { TrackingProvider } from '@/common/contexts/TrackingContext';
import AgeGate from '@/common/components/ageGate/AgeGate';
import CookieConsent from '@/common/components/cookieConsent/CookieConsent';

const queryClient = new QueryClient();

interface AppProvidersProps {
	children: ReactNode;
}

const AppProviders = ({ children }: AppProvidersProps) => {
	return (
		<BrowserRouter>
			<QueryClientProvider client={queryClient}>
				<TrackingProvider>
					<LanguageContextProvider>
						<AgeGate>
							<MessageContextProvider>
								<AudioRecordingContextProvider>
									<AnalyticsProvider>
										<GuestAuthProvider>{children}</GuestAuthProvider>
									</AnalyticsProvider>
								</AudioRecordingContextProvider>
							</MessageContextProvider>
							<CookieConsent />
						</AgeGate>
					</LanguageContextProvider>
				</TrackingProvider>
			</QueryClientProvider>
		</BrowserRouter>
	);
};

export default AppProviders;
